// TODO: Polyfill or alter before release
export function applyParamFromWindow(urlToMutate, paramName) {
    var windowSearchParams = new URLSearchParams(window.location.search);
    var windowValue = windowSearchParams.get(paramName);
    if (!windowValue) {
        return;
    }
    urlToMutate.searchParams.set(paramName, windowValue);
}
//# sourceMappingURL=applyParamFromWindow.js.map